import { TemplateInfo } from './info'
import { Similar } from './similar'
import VideoPlayer from '~/components/videoPlayer/index.vue'
import type { Template } from '~/api/interface'
import RightArrow from '~/assets/svg/arrow-white.svg?url'
import Resource from '~/components/resource'
import { PageKey } from '~/constants/page'

export const TemplateDetail = defineComponent({
  props: {
    list: {
      type: Object as PropType<Template[]>,
    },
    item: {
      type: Object as PropType<Template>,
    },
    onChange: {
      type: Function as PropType<
        ([key, value]: [string, any], data: Template) => void
      >,
      default: () => ({}),
    },
  },
  setup(props, { expose }) {
    const { $t } = useNuxtApp()
    const route = useRoute()
    const template = useTemplateState()
    const showToggle = route.name !== PageKey.SITE_SEARCH // 全站搜索不展示左右切换

    provideResourceLocation({
      source: template.value.source,
    })

    const activeIndex = computed(() => {
      if (!template.value.active) {
        return -1
      }

      const index = template.value.list?.findIndex(
        (x: { id: any }) => x.id === template.value.active?.id
      )
      return index
    })

    const next = (type: 1 | -1) => {
      template.value.active = template.value.list[activeIndex.value + type]
    }

    const onChange = ([key, value]: [string, any]) => {
      if (template.value.active) {
        template.value.active[key] = value
      }

      template.value?.changeCallback?.([key, value], template.value.active)
    }

    const onSimilarClick = (list: Template[], data: Template) => {
      template.value.list = list
      template.value.active = data
    }

    onMounted(() => {
      trackEvent(TRACK_EVENT.PLAY_TEMPLATE_VIDEO, {
        source: template.value.source,
        template_id: template.value.id,
        template_title: template.value.title,
      })
    })

    return () => {
      return (
        <div class="p-[24px]">
          <div class="flex mb-[30px]">
            <div class="w-[580px] h-[326px] rounded-[10px] bg-[#2B2B2E] mr-[20px] overflow-hidden">
              {template.value.active?.full_video_url && (
                <VideoPlayer
                  url={template.value.active?.full_video_url}
                  auto-url={template.value.active?.preview_m3u8_url}
                  class="mr-[20px]"
                  id={template.value.active?.id}
                  type="template"
                />
              )}
            </div>
            {template.value.active && (
              <TemplateInfo
                data={template.value.active}
                onChange={(params: any) => onChange(params)}
                templateSource={template.value.templateSource}
              />
            )}
          </div>
          {template.value.active && (
            <Similar
              title={
                template.value.templateSource ===
                TEMPLATE_SOURCE.BEST_PRACTICE_PAGE
                  ? $t('qi-ta-chuang-zuo-zhe-zuo-pin')
                  : $t('xiang-si-tui-jian')
              }
              active={template.value.active}
              onSimilarClick={onSimilarClick}
              isBestPractice={
                template.value.templateSource ===
                TEMPLATE_SOURCE.BEST_PRACTICE_PAGE
              }
            />
          )}
          {activeIndex.value > 0 && showToggle && (
            <div
              class="absolute -left-[60px] top-[50%] w-[50px] h-[50px] rounded-full bg-[rgba(235,235,235,0)]  cursor-pointer hover:bg-[rgba(235,235,235,0.2)] flex-y-center justify-center"
              onClick={() => next(-1)}
            >
              <Resource
                src={RightArrow}
                class="w-[26px] h-[26px] rotate-180 mr-[5px]"
              />
            </div>
          )}
          {activeIndex.value < template.value.list?.length - 1 &&
            showToggle && (
              <div
                onClick={() => next(1)}
                class=" w-[50px] h-[50px] rounded-full bg-[rgba(235,235,235,0)] cursor-pointer hover:bg-[rgba(235,235,235,0.2)]  absolute top-[50%] text-white text-[30px] right-[-60px] flex-y-center justify-center"
              >
                <Resource src={RightArrow} class="w-[26px] h-[26px] ml-[5px]" />
              </div>
            )}
        </div>
      )
    }
  },
})
